import React from 'react';
import ListFetchErrorStateBase from './list-fetch-error-state-base';
import { DEFAULT_LIST_FETCH_ERROR } from '../../common/constants/data-hooks';
const DefaultListFetchErrorState = ({ onRetry }) => {
    return (React.createElement(ListFetchErrorStateBase, { onRetry: onRetry, dataHook: DEFAULT_LIST_FETCH_ERROR, primaryKey: "empty-state.list-fetch-error", secondaryKey: "empty-state.list-fetch-error-subtext", ctaKey: "empty-state.list-fetch-error-try-again" }));
};
export default DefaultListFetchErrorState;
//# sourceMappingURL=default-list-fetch-error-state.js.map